<template>
  <div v-if="client">
    <!-- title -->
    <p class="title is-3 oc-client">{{ client.name }}</p>

    <router-view />
  </div>
</template>
<script>
  import state from '../../../state'
  import breadcrumbsService from '../../../services/breadcrumbs.service'

  export default {
    name: 'client',
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      client() {
        return state.clients.getClient(this.clientId);
      }
    },
    async mounted() {
      breadcrumbsService.dynamic.set({ key: 'client', func: () => this.client ? this.client.name : '' });
    }
  }
</script>
<style scoped>
  .oc-client {
    color: #c02c2c !important;
  }
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/index.vue